import { render, staticRenderFns } from "./SMSCostsDashboard.vue?vue&type=template&id=77e89067&scoped=true&"
import script from "./SMSCostsDashboard.vue?vue&type=script&lang=js&"
export * from "./SMSCostsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SMSCostsDashboard.vue?vue&type=style&index=0&id=77e89067&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e89067",
  null
  
)

export default component.exports